import { FlexView } from '@cuemath/comps';
import styled, { keyframes } from 'styled-components';
import LAYOUT from 'constants/layout';
import PausePolicy from './pause-policy';
import React from 'react';

const FadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
const Container = styled(FlexView)`
  padding: 0 ${LAYOUT.GUTTER}px;
  animation: ${FadeIn} 0.5s ease-in-out;
`;

const PauseDetails = () => {
  return (
    <Container>
      <PausePolicy />
    </Container>
  );
};

export default PauseDetails;
